module.exports = __webpack_public_path__ + "img/map-nt.97c67def.png";